<template>
  <v-container>
    <h3 class="mb-3 text-center">إضافة وكيل جديد</h3>
    <AgentForm>
      <template v-slot:default="slotProps">
        <v-btn
          class="ma-1"
          :disabled="slotProps.disabled"
          @click="createNewAgent(slotProps.agent)"
          >نعم، أضف هذا الوكيل</v-btn
        >
        <v-btn class="ma-1" @click="$router.go(-1)"
          >لا، لا. عد من حيث أتيت</v-btn
        >
      </template>
    </AgentForm>
  </v-container>
</template>

<script>
import AgentForm from "./components/AgentForm";
import { create } from "@/services/agentApi";

export default {
  components: { AgentForm },
  methods: {
    async createNewAgent(agent) {
      const result = await create(agent);
      this.$router.go(-1);
    },
  },
};
</script>

<style>
</style>